import { NewSingleFormComponentProps } from "../components/new_form/NewSingleFormComponent";

export function getPhysicalLibraryLocationForm(): NewSingleFormComponentProps {
  return {
    formFields: [
      {
        type: "text",
        key: "name",
        required: true,
        label: "Name",
        placeholder: "Physical Library Location Name",
      },
    ],
    type: "single_form",
  };
}
